import React from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
import { HeartHandshakeIcon } from 'lucide-react';
export function FGMHopeClinic() {
  const {
    t
  } = useLanguage();
  return <section id="clinic" className="py-20 bg-teal-50" data-id="element-112">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-sm text-center border border-teal-100/50" data-id="element-114">
          <div className="w-16 h-16 bg-teal-50 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-115">
            <HeartHandshakeIcon size={32} data-id="element-116" />
          </div>

          <h2 className="text-3xl font-serif font-medium text-teal-900 mb-6" data-id="element-117">
            {t.fgm.title}
          </h2>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-118">
            {t.fgm.text}
          </p>

          <button className="bg-teal-50 hover:bg-teal-100 text-teal-700 px-8 py-3 rounded-full font-medium transition-colors" data-id="element-119">
            {t.fgm.button}
          </button>
        </motion.div>
      </div>
    </section>;
}